import { useEffect } from 'react';

const useBlur = (ref, addExpandedClass) => {
  const getParentSection = (element) => {
    if (!element) return null;

    let parent = element;
    while (parent && !parent?.id?.startsWith('section-') && parent.parentNode?.tagName !== 'MAIN') {
      parent = parent.parentNode;
    }
    return parent;
  };

  useEffect(() => {
    let section = getParentSection(ref?.current);
    const hasBlur = window.document.getElementById(`blur-${section?.id}`);
    if (!hasBlur && section) {
      const blurContainer = window.document.createElement('div');
      blurContainer.classList.add('blur-container');
      blurContainer.id = `blur-${section.id}`;

      if (addExpandedClass) blurContainer.classList.add('expand');

      section.firstChild.appendChild(blurContainer);
    }
    return () => {
      window.document.getElementById(`blur-${section?.id}`)?.remove();
    };
  }, []);
};

export default useBlur;
